import Vue from 'vue'
import resetRow from '@/views/template-configuration/utils/component/reset-row'
import store from '../store'
const resetRows = Vue.extend({ ...resetRow, store })
export default {
	install() {
		Vue.prototype.$bigScore = function(options) {
			const scoreDomOrigin = document.getElementById('bigScore')
			if (scoreDomOrigin) document.body.removeChild(scoreDomOrigin)
			const bigScore = new Vue({
				render(createElement) {
					return createElement(
						'div',
						{
							style: {
								position: 'fixed',
								top: '0',
								left: '0',
								width: '100%',
								height: '100%',
								zIndex: '1000',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center'
							},
							attrs: {
								id: 'bigScore'
							}
						},
						[
							createElement('div', [
								createElement('span', {
									domProps: {
										innerText: options.score
									},
									style: { color: 'red', fontWeight: 'bold', fontSize: '85px', display: 'block', paddingLeft: '30px' }
								}),
								createElement('i', {
									class: ['iconfont', 'iconfenshu10'],
									style: { color: 'red', fontSize: '88px' }
								})
							])
						]
					)
				}
			})
			bigScore.$mount()
			options.dom.appendChild(bigScore.$el)
			const scoreDom = document.getElementById('bigScore')
			setTimeout(function() {
				try {
					options.dom.removeChild(scoreDom)
				} catch (e) {
					console.log(e)
				}
			}, 300)
		}
		Vue.prototype.$resetRow = function(options, direction) {
			console.log(options, direction)
			let instance = new resetRows().$mount()
			document.body.appendChild(instance.$el)
			instance.getOptions(options, direction)
		}
	}
}
